
export const countries = [
  { code: 'AD', name: 'Andorra', hagueConvention: true },
  { code: 'AE', name: 'United Arab Emirates', hagueConvention: true },
  { code: 'AF', name: 'Afghanistan', hagueConvention: false },
  { code: 'AG', name: 'Antigua and Barbuda', hagueConvention: true },
  { code: 'AI', name: 'Anguilla', hagueConvention: false },
  { code: 'AL', name: 'Albania', hagueConvention: true },
  { code: 'AM', name: 'Armenia', hagueConvention: true },
  { code: 'AO', name: 'Angola', hagueConvention: false },
  { code: 'AQ', name: 'Antarctica', hagueConvention: false },
  { code: 'AR', name: 'Argentina', hagueConvention: true },
  { code: 'AS', name: 'American Samoa', hagueConvention: false },
  { code: 'AT', name: 'Austria', hagueConvention: true },
  { code: 'AU', name: 'Australia', hagueConvention: true },
  { code: 'AW', name: 'Aruba', hagueConvention: false },
  { code: 'AX', name: 'Åland Islands', hagueConvention: false },
  { code: 'AZ', name: 'Azerbaijan', hagueConvention: true },
  { code: 'BA', name: 'Bosnia and Herzegovina', hagueConvention: true },
  { code: 'BB', name: 'Barbados', hagueConvention: true },
  { code: 'BD', name: 'Bangladesh', hagueConvention: false },
  { code: 'BE', name: 'Belgium', hagueConvention: true },
  { code: 'BF', name: 'Burkina Faso', hagueConvention: false },
  { code: 'BG', name: 'Bulgaria', hagueConvention: true },
  { code: 'BH', name: 'Bahrain', hagueConvention: true },
  { code: 'BI', name: 'Burundi', hagueConvention: false },
  { code: 'BJ', name: 'Benin', hagueConvention: false },
  { code: 'BL', name: 'Saint Barthélemy', hagueConvention: false },
  { code: 'BM', name: 'Bermuda', hagueConvention: false },
  { code: 'BN', name: 'Brunei Darussalam', hagueConvention: true },
  { code: 'BO', name: 'Bolivia', hagueConvention: false },
  { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba', hagueConvention: false },
  { code: 'BR', name: 'Brazil', hagueConvention: false },
  { code: 'BS', name: 'Bahamas', hagueConvention: true },
  { code: 'BT', name: 'Bhutan', hagueConvention: false },
  { code: 'BV', name: 'Bouvet Island', hagueConvention: false },
  { code: 'BW', name: 'Botswana', hagueConvention: true },
  { code: 'BY', name: 'Belarus', hagueConvention: true },
  { code: 'BZ', name: 'Belize', hagueConvention: true },
  { code: 'CA', name: 'Canada', hagueConvention: false },
  { code: 'CC', name: 'Cocos (Keeling) Islands', hagueConvention: false },
  { code: 'CD', name: 'Congo, Democratic Republic of the', hagueConvention: false },
  { code: 'CF', name: 'Central African Republic', hagueConvention: false },
  { code: 'CG', name: 'Congo', hagueConvention: false },
  { code: 'CH', name: 'Switzerland', hagueConvention: true },
  { code: 'CI', name: 'Côte d\'Ivoire', hagueConvention: false },
  { code: 'CK', name: 'Cook Islands', hagueConvention: true },
  { code: 'CL', name: 'Chile', hagueConvention: true },
  { code: 'CM', name: 'Cameroon', hagueConvention: false },
  { code: 'CN', name: 'China', hagueConvention: true },
  { code: 'CO', name: 'Colombia', hagueConvention: true },
  { code: 'CR', name: 'Costa Rica', hagueConvention: true },
  { code: 'CU', name: 'Cuba', hagueConvention: false },
  { code: 'CV', name: 'Cabo Verde', hagueConvention: true },
  { code: 'CW', name: 'Curaçao', hagueConvention: false },
  { code: 'CX', name: 'Christmas Island', hagueConvention: false },
  { code: 'CY', name: 'Cyprus', hagueConvention: true },
  { code: 'CZ', name: 'Czech Republic', hagueConvention: true },
  { code: 'DE', name: 'Germany', hagueConvention: true },
  { code: 'DJ', name: 'Djibouti', hagueConvention: false },
  { code: 'DK', name: 'Denmark', hagueConvention: true },
  { code: 'DM', name: 'Dominica', hagueConvention: true },
  { code: 'DO', name: 'Dominican Republic', hagueConvention: true },
  { code: 'DZ', name: 'Algeria', hagueConvention: false },
  { code: 'EC', name: 'Ecuador', hagueConvention: true },
  { code: 'EE', name: 'Estonia', hagueConvention: true },
  { code: 'EG', name: 'Egypt', hagueConvention: false },
  { code: 'EH', name: 'Western Sahara', hagueConvention: false },
  { code: 'ER', name: 'Eritrea', hagueConvention: false },
  { code: 'ES', name: 'Spain', hagueConvention: true },
  { code: 'ET', name: 'Ethiopia', hagueConvention: false },
  { code: 'FI', name: 'Finland', hagueConvention: true },
  { code: 'FJ', name: 'Fiji', hagueConvention: true },
  { code: 'FK', name: 'Falkland Islands (Malvinas)', hagueConvention: false },
  { code: 'FM', name: 'Micronesia, Federated States of', hagueConvention: false },
  { code: 'FO', name: 'Faroe Islands', hagueConvention: false },
  { code: 'FR', name: 'France', hagueConvention: true },
  { code: 'GA', name: 'Gabon', hagueConvention: false },
  { code: 'GB', name: 'United Kingdom', hagueConvention: true },
  { code: 'GD', name: 'Grenada', hagueConvention: true },
  { code: 'GE', name: 'Georgia', hagueConvention: true },
  { code: 'GF', name: 'French Guiana', hagueConvention: false },
  { code: 'GG', name: 'Guernsey', hagueConvention: false },
  { code: 'GH', name: 'Ghana', hagueConvention: false },
  { code: 'GI', name: 'Gibraltar', hagueConvention: false },
  { code: 'GL', name: 'Greenland', hagueConvention: false },
  { code: 'GM', name: 'Gambia', hagueConvention: false },
  { code: 'GN', name: 'Guinea', hagueConvention: false },
  { code: 'GP', name: 'Guadeloupe', hagueConvention: false },
  { code: 'GQ', name: 'Equatorial Guinea', hagueConvention: false },
  { code: 'GR', name: 'Greece', hagueConvention: true },
  { code: 'GS', name: 'South Georgia and the South Sandwich Islands', hagueConvention: false },
  { code: 'GT', name: 'Guatemala', hagueConvention: false },
  { code: 'GU', name: 'Guam', hagueConvention: false },
  { code: 'GW', name: 'Guinea-Bissau', hagueConvention: false },
  { code: 'GY', name: 'Guyana', hagueConvention: false },
  { code: 'HK', name: 'Hong Kong', hagueConvention: true },
  { code: 'HM', name: 'Heard Island and McDonald Islands', hagueConvention: false },
  { code: 'HN', name: 'Honduras', hagueConvention: true },
  { code: 'HR', name: 'Croatia', hagueConvention: true },
  { code: 'HT', name: 'Haiti', hagueConvention: false },
  { code: 'HU', name: 'Hungary', hagueConvention: true },
  { code: 'ID', name: 'Indonesia', hagueConvention: false },
  { code: 'IE', name: 'Ireland', hagueConvention: true },
  { code: 'IL', name: 'Israel', hagueConvention: true },
  { code: 'IM', name: 'Isle of Man', hagueConvention: false },
  { code: 'IN', name: 'India', hagueConvention: true },
  { code: 'IO', name: 'British Indian Ocean Territory', hagueConvention: false },
  { code: 'IQ', name: 'Iraq', hagueConvention: false },
  { code: 'IR', name: 'Iran, Islamic Republic of', hagueConvention: false },
  { code: 'IS', name: 'Iceland', hagueConvention: true },
  { code: 'IT', name: 'Italy', hagueConvention: true },
  { code: 'JE', name: 'Jersey', hagueConvention: false },
  { code: 'JM', name: 'Jamaica', hagueConvention: false },
  { code: 'JO', name: 'Jordan', hagueConvention: false },
  { code: 'JP', name: 'Japan', hagueConvention: true },
  { code: 'KE', name: 'Kenya', hagueConvention: false },
  { code: 'KG', name: 'Kyrgyzstan', hagueConvention: true },
  { code: 'KH', name: 'Cambodia', hagueConvention: false },
  { code: 'KI', name: 'Kiribati', hagueConvention: false },
  { code: 'KM', name: 'Comoros', hagueConvention: false },
  { code: 'KN', name: 'Saint Kitts and Nevis', hagueConvention: true },
  { code: 'KP', name: 'Korea, Democratic People\'s Republic of', hagueConvention: false },
  { code: 'KR', name: 'Korea, Republic of', hagueConvention: true },
  { code: 'KW', name: 'Kuwait', hagueConvention: true },
  { code: 'KY', name: 'Cayman Islands', hagueConvention: false },
  { code: 'KZ', name: 'Kazakhstan', hagueConvention: true },
  { code: 'LA', name: 'Lao People\'s Democratic Republic', hagueConvention: false },
  { code: 'LB', name: 'Lebanon', hagueConvention: false },
  { code: 'LC', name: 'Saint Lucia', hagueConvention: true },
  { code: 'LI', name: 'Liechtenstein', hagueConvention: true },
  { code: 'LK', name: 'Sri Lanka', hagueConvention: false },
  { code: 'LR', name: 'Liberia', hagueConvention: true },
  { code: 'LS', name: 'Lesotho', hagueConvention: true },
  { code: 'LT', name: 'Lithuania', hagueConvention: true },
  { code: 'LU', name: 'Luxembourg', hagueConvention: true },
  { code: 'LV', name: 'Latvia', hagueConvention: true },
  { code: 'LY', name: 'Libya', hagueConvention: false },
  { code: 'MA', name: 'Morocco', hagueConvention: true },
  { code: 'MC', name: 'Monaco', hagueConvention: true },
  { code: 'MD', name: 'Moldova, Republic of', hagueConvention: true },
  { code: 'ME', name: 'Montenegro', hagueConvention: true },
  { code: 'MF', name: 'Saint Martin (French part)', hagueConvention: false },
  { code: 'MG', name: 'Madagascar', hagueConvention: false },
  { code: 'MH', name: 'Marshall Islands', hagueConvention: true },
  { code: 'MK', name: 'North Macedonia', hagueConvention: true },
  { code: 'ML', name: 'Mali', hagueConvention: false },
  { code: 'MM', name: 'Myanmar', hagueConvention: false },
  { code: 'MN', name: 'Mongolia', hagueConvention: true },
  { code: 'MO', name: 'Macao', hagueConvention: true },
  { code: 'MP', name: 'Northern Mariana Islands', hagueConvention: false },
  { code: 'MQ', name: 'Martinique', hagueConvention: false },
  { code: 'MR', name: 'Mauritania', hagueConvention: false },
  { code: 'MS', name: 'Montserrat', hagueConvention: false },
  { code: 'MT', name: 'Malta', hagueConvention: true },
  { code: 'MU', name: 'Mauritius', hagueConvention: true },
  { code: 'MV', name: 'Maldives', hagueConvention: false },
  { code: 'MW', name: 'Malawi', hagueConvention: true },
  { code: 'MX', name: 'Mexico', hagueConvention: true },
  { code: 'MY', name: 'Malaysia', hagueConvention: false },
  { code: 'MZ', name: 'Mozambique', hagueConvention: false },
  { code: 'NA', name: 'Namibia', hagueConvention: true },
  { code: 'NC', name: 'New Caledonia', hagueConvention: false },
  { code: 'NE', name: 'Niger', hagueConvention: false },
  { code: 'NF', name: 'Norfolk Island', hagueConvention: false },
  { code: 'NG', name: 'Nigeria', hagueConvention: false },
  { code: 'NI', name: 'Nicaragua', hagueConvention: true },
  { code: 'NL', name: 'Netherlands', hagueConvention: true },
  { code: 'NO', name: 'Norway', hagueConvention: true },
  { code: 'NP', name: 'Nepal', hagueConvention: false },
  { code: 'NR', name: 'Nauru', hagueConvention: false },
  { code: 'NU', name: 'Niue', hagueConvention: true },
  { code: 'NZ', name: 'New Zealand', hagueConvention: true },
  { code: 'OM', name: 'Oman', hagueConvention: true },
  { code: 'PA', name: 'Panama', hagueConvention: true },
  { code: 'PE', name: 'Peru', hagueConvention: true },
  { code: 'PF', name: 'French Polynesia', hagueConvention: false },
  { code: 'PG', name: 'Papua New Guinea', hagueConvention: false },
  { code: 'PH', name: 'Philippines', hagueConvention: true },
  { code: 'PK', name: 'Pakistan', hagueConvention: false },
  { code: 'PL', name: 'Poland', hagueConvention: true },
  { code: 'PM', name: 'Saint Pierre and Miquelon', hagueConvention: false },
  { code: 'PN', name: 'Pitcairn', hagueConvention: false },
  { code: 'PR', name: 'Puerto Rico', hagueConvention: false },
  { code: 'PS', name: 'Palestine, State of', hagueConvention: false },
  { code: 'PT', name: 'Portugal', hagueConvention: true },
  { code: 'PW', name: 'Palau', hagueConvention: false },
  { code: 'PY', name: 'Paraguay', hagueConvention: true },
  { code: 'QA', name: 'Qatar', hagueConvention: false },
  { code: 'RE', name: 'Réunion', hagueConvention: false },
  { code: 'RO', name: 'Romania', hagueConvention: true },
  { code: 'RS', name: 'Serbia', hagueConvention: true },
  { code: 'RU', name: 'Russian Federation', hagueConvention: true },
  { code: 'RW', name: 'Rwanda', hagueConvention: false },
  { code: 'SA', name: 'Saudi Arabia', hagueConvention: false },
  { code: 'SB', name: 'Solomon Islands', hagueConvention: false },
  { code: 'SC', name: 'Seychelles', hagueConvention: false },
  { code: 'SD', name: 'Sudan', hagueConvention: false },
  { code: 'SE', name: 'Sweden', hagueConvention: true },
  { code: 'SG', name: 'Singapore', hagueConvention: false },
  { code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha', hagueConvention: false },
  { code: 'SI', name: 'Slovenia', hagueConvention: true },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', hagueConvention: false },
  { code: 'SK', name: 'Slovakia', hagueConvention: true },
  { code: 'SL', name: 'Sierra Leone', hagueConvention: false },
  { code: 'SM', name: 'San Marino', hagueConvention: true },
  { code: 'SN', name: 'Senegal', hagueConvention: false },
  { code: 'SO', name: 'Somalia', hagueConvention: false },
  { code: 'SR', name: 'Suriname', hagueConvention: true },
  { code: 'SS', name: 'South Sudan', hagueConvention: false },
  { code: 'ST', name: 'Sao Tome and Principe', hagueConvention: false },
  { code: 'SV', name: 'El Salvador', hagueConvention: true },
  { code: 'SX', name: 'Sint Maarten (Dutch part)', hagueConvention: false },
  { code: 'SY', name: 'Syrian Arab Republic', hagueConvention: false },
  { code: 'SZ', name: 'Eswatini', hagueConvention: true },
  { code: 'TC', name: 'Turks and Caicos Islands', hagueConvention: false },
  { code: 'TD', name: 'Chad', hagueConvention: false },
  { code: 'TF', name: 'French Southern Territories', hagueConvention: false },
  { code: 'TG', name: 'Togo', hagueConvention: false },
  { code: 'TH', name: 'Thailand', hagueConvention: false },
  { code: 'TJ', name: 'Tajikistan', hagueConvention: true },
  { code: 'TK', name: 'Tokelau', hagueConvention: false },
  { code: 'TL', name: 'Timor-Leste', hagueConvention: false },
  { code: 'TM', name: 'Turkmenistan', hagueConvention: false },
  { code: 'TN', name: 'Tunisia', hagueConvention: true },
  { code: 'TO', name: 'Tonga', hagueConvention: true },
  { code: 'TR', name: 'Turkey', hagueConvention: true },
  { code: 'TT', name: 'Trinidad and Tobago', hagueConvention: true },
  { code: 'TV', name: 'Tuvalu', hagueConvention: false },
  { code: 'TW', name: 'Taiwan, Province of China', hagueConvention: false },
  { code: 'TZ', name: 'Tanzania, United Republic of', hagueConvention: false },
  { code: 'UA', name: 'Ukraine', hagueConvention: true },
  { code: 'UG', name: 'Uganda', hagueConvention: false },
  { code: 'UM', name: 'United States Minor Outlying Islands', hagueConvention: false },
  { code: 'US', name: 'United States of America', hagueConvention: true },
  { code: 'UY', name: 'Uruguay', hagueConvention: true },
  { code: 'UZ', name: 'Uzbekistan', hagueConvention: true },
  { code: 'VA', name: 'Holy See (Vatican City State)', hagueConvention: false },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', hagueConvention: true },
  { code: 'VE', name: 'Venezuela, Bolivarian Republic of', hagueConvention: true },
  { code: 'VG', name: 'Virgin Islands, British', hagueConvention: false },
  { code: 'VI', name: 'Virgin Islands, U.S.', hagueConvention: false },
  { code: 'VN', name: 'Viet Nam', hagueConvention: false },
  { code: 'VU', name: 'Vanuatu', hagueConvention: true },
  { code: 'WF', name: 'Wallis and Futuna', hagueConvention: false },
  { code: 'WS', name: 'Samoa', hagueConvention: true },
  { code: 'YE', name: 'Yemen', hagueConvention: false },
  { code: 'YT', name: 'Mayotte', hagueConvention: false },
  { code: 'ZA', name: 'South Africa', hagueConvention: true },
  { code: 'ZM', name: 'Zambia', hagueConvention: false },
  { code: 'ZW', name: 'Zimbabwe', hagueConvention: false }
];

export const documentTypes = [
  'Birth Certificate',
  'Death Certificate',
  'Marriage Certificate',
  'Divorce Decree',
  'Adoption Certificate',
  'Power of Attorney',
  'Affidavit',
  'Corporate Documents',
  'Educational Transcripts',
  'Diploma/Degree',
  'FBI Background Check',
  'State Background Check',
  'Medical Records',
  'Patent Documents',
  'Trademark Documents',
  'Court Documents',
  'Notarized Documents',
  'Other'
];

export const paymentTypes = [
  'Cash',
  'Check',
  'Credit Card',
  'Debit Card',
  'Bank Transfer',
  'PayPal',
  'Venmo',
  'Zelle',
  'Money Order',
  'Other'
];

export const courierCompanies = [
  'FedEx',
  'UPS',
  'USPS',
  'DHL',
  'OnTrac',
  'LaserShip',
  'Amazon Logistics',
  'Local Courier',
  'Hand Delivery',
  'Other'
];
